module.exports = __webpack_public_path__ + "img/Trifolium_pratense.be5f9b52.jpg";